var exports = {
  "kL": "xcc377c0b--db0b0c--container",
  "nM": "xcc377c0b--db0b0c--row",
  "RI": "xcc377c0b--db0b0c--room-type",
  "q9": "xcc377c0b--db0b0c--price",
  "z8": "xcc377c0b--db0b0c--props-count",
  "UE": "xcc377c0b--db0b0c--arrow",
};

module.exports = exports;
